import axios from "../utils/axios";

export const getHomeHeaderSection = async () => {
    const response = await axios.get('/settings/home-header-page');
    return response.data;
};

export const updateHomeHeaderSection = async (data) => {
    const response = await axios.put('/settings/home-header-page', data);
    return response.data;
};
